<template>
  <div>
    <img :src="logo" alt="Logo Oasis" :style="css">
  </div>
</template>
  
  <script>
  export default {
    props:['css'],
    data() {
      return {
        logo:"/logo.png",
      };
    },
    
    mounted() {
        let self = this;
        const fechaActual = new Date();
        const mes = fechaActual.getMonth() + 1; // Mes (0 = enero, por lo que se suma 1)
        if(mes === 12){self.logo = "/logo-dic2.png";}
        else if(mes === 10){self.logo = "/logo-dic.png";}
        else if (mes >= 3 && mes <= 5) {self.logo = "/logo-ver1.png";}
        else if (mes >= 6 && mes <= 8) {self.logo = "/logo-inv1.png";}
      },
    methods: {
    },  
  }
</script>
<style>
  .icon-transition {
    transition: all 0.9s ease;
    opacity: 1;
  }
</style>